import { FLEXIBLE_REMUNERATION_REQUESTS_SKU } from '../../constants/requests';
import { IFlexibleRemunerationRequest } from '../../interfaces/company';
import { IUpdateFlexibleRemunerationRequestBody } from '../../interfaces/requests';
import type { HealthRequestBody, RequestStatus, TrainingRequestBody } from '../../types/flexibleRemuneration';
import { convertDDMMYYYYToISO } from '../datetime/datetime';

export const RequestPayloadBuilder = (
  request: IFlexibleRemunerationRequest,
  params: {
    type: RequestStatus;
    newPayments?: TrainingRequestBody;
    newHealthDates?: HealthRequestBody;
  }
): IUpdateFlexibleRemunerationRequestBody => {
  const originalPayments = (request.details?.payments || []).filter((p) => /\d{4}-\d{2}/.test(p.month));

  if (params.type === 'active') {
    if (request.sku === FLEXIBLE_REMUNERATION_REQUESTS_SKU.health) {
      const startDate = convertDDMMYYYYToISO(params.newHealthDates?.startDate || '');
      const renewalDate = convertDDMMYYYYToISO(params.newHealthDates?.renewalDate || '', true);
      return {
        sku: request.sku,
        status: 'approved',
        startDate,
        renewalDate
      };
    }

    const provided = (params.newPayments || []).filter((p) => /\d{4}-\d{2}/.test(p.month));
    const serialize = (arr: { month: string; amount: number }[]) =>
      arr
        .map((p) => `${p.month}|${p.amount}`)
        .sort((a, b) => a.localeCompare(b))
        .join(';');
    const paymentsHasChanged = serialize(originalPayments) !== serialize(provided);
    const startDate = request.details.startDate;
    return {
      sku: request.sku,
      status: 'active',
      payments: provided,
      startDate,
      paymentsHasChanged
    };
  }

  return {
    sku: request.sku,
    status: params.type
  };
};
